


























import { defineComponent, ref, toRefs } from '@nuxtjs/composition-api'
import { formFieldProps } from '~/constants/form'
import { useClassifiedForm } from '~/compositions/form'
import { Ref } from '@vue/composition-api'

interface TireField {
  value: number | null
  label: string
}

export default defineComponent({
  props: formFieldProps,
  setup(props) {
    const { name } = toRefs(props)
    const tireFields = ref<Record<string, TireField>>({
      width: {
        value: null,
        label: 'Πλάτος λάστιχου'
      },
      ratio: {
        value: null,
        label: 'Προφίλ λάστιχου'
      },
      diameter: {
        value: null,
        label: 'Διάμετρος Λάστιχου'
      }
    })

    const { debouncedValueChanged } = useClassifiedForm(props, {
      onValue: (
        v: Ref<{
          width: number | null
          diameter: number | null
          ratio: number | null
        }>
      ) => {
        tireFields.value.width.value = v.value?.width
        tireFields.value.diameter.value = v.value?.diameter
        tireFields.value.ratio.value = v.value?.ratio
      }
    })

    function handleFieldChange() {
      const width = tireFields.value.width.value
      const diameter = tireFields.value.diameter.value
      const ratio = tireFields.value.ratio.value

      debouncedValueChanged(name.value, {
        ratio: ratio ? Number(ratio) : null,
        width: width ? Number(width) : null,
        diameter: diameter ? Number(diameter) : null
      })
    }

    return { tireFields, handleFieldChange }
  }
})
